(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-name-field"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-char-limit]').forEach(function (input) {
      var limit = parseInt(input.dataset.charLimit, 10);
      var msg = document.getElementById(input.id + '-msg');

      input.addEventListener('input', function () {
        if (input.value.length >= limit) {
          input.value = input.value.slice(0, limit);
          if (msg) msg.style.display = 'block';
        } else {
          if (msg) msg.style.display = 'none';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rewards-popup-rewards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rewards-popup')) {
    customElements.define('rewards-popup', class extends HTMLElement {
      connectedCallback() {
        this.setupTimer = setTimeout(() => this.setup(), 0);
      }

      setup() {
        if (!this.isConnected || this.controller) return;
        this.dialog = this.querySelector('.rp-dialog');
        this.backdrop = this.querySelector('.rp-backdrop');
        this.closeButton = this.querySelector('.rp-close');
        if (!this.dialog || !this.backdrop || !this.closeButton) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.closeButton.addEventListener('click', () => this.closePopup(), options);
        this.backdrop.addEventListener('click', () => this.closePopup(), options);
        this.addEventListener('keydown', (event) => {
          if (!this.isOpen) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            this.closePopup();
          }
          if (event.key === 'Tab') {
            const items = Array.from(this.dialog.querySelectorAll('button, a[href], [tabindex="0"]'))
              .filter((item) => !item.disabled && item.getClientRects().length);
            const first = items[0];
            const last = items[items.length - 1];
            if (event.shiftKey && document.activeElement === first) {
              event.preventDefault();
              last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
              event.preventDefault();
              first.focus();
            }
          }
        }, options);
        const section = this.closest('.shopify-section');
        if (section && window.Shopify && Shopify.designMode) {
          section.addEventListener('shopify:section:select', () => this.openPopup(), options);
          section.addEventListener('shopify:block:select', () => this.openPopup(), options);
        }
        if (this.dataset.forceShow === 'true') {
          this.openPopup();
          return;
        }
        if (this.dataset.enable !== 'true' || this.dataset.isHome !== 'true') return;
        try {
          if (this.dataset.showOnce === 'true' && localStorage.getItem(this.dataset.key) === '1') return;
        } catch (error) {}
        this.openTimer = setTimeout(() => this.openPopup(), Math.max(0, Number(this.dataset.openDelay) || 0));
      }

      openPopup() {
        clearTimeout(this.openTimer);
        if (this.isOpen || !this.isConnected) return;
        this.isOpen = true;
        this.previousFocus = document.activeElement;
        this.dialog.style.display = 'grid';
        this.backdrop.style.display = 'block';
        this.closeButton.focus({ preventScroll: true });
        if (this.dataset.showOnce === 'true' && !(window.Shopify && Shopify.designMode)) {
          try { localStorage.setItem(this.dataset.key, '1'); } catch (error) {}
        }
      }

      closePopup() {
        clearTimeout(this.openTimer);
        if (!this.isOpen) return;
        this.isOpen = false;
        this.dialog.style.display = 'none';
        this.backdrop.style.display = 'none';
        if (this.previousFocus && this.previousFocus.isConnected) {
          this.previousFocus.focus({ preventScroll: true });
        }
      }

      disconnectedCallback() {
        clearTimeout(this.setupTimer);
        clearTimeout(this.openTimer);
        this.closePopup();
        if (this.controller) this.controller.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
